import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Replace this with your actual auth logic (e.g., useAuth() hook)
  const isAuthenticated = true;
  
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // 1. Log the error
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // 2. Setup the countdown interval
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    // 3. Handle navigation when countdown hits 0
    if (countdown === 0) {
      const destination = isAuthenticated ? "/welcome" : "/";
      navigate(destination);
    }

    // Cleanup interval on unmount
    return () => clearInterval(timer);
  }, [location.pathname, countdown, navigate, isAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8 bg-white shadow-xl rounded-lg">
        <h1 className="text-4xl font-bold mb-4 text-red-600">404</h1>
        <h2 className="text-2xl font-semibold mb-2">
          Even our server could not find this.
        </h2>
        <p className="text-gray-600 mb-6">
          And it finds everything... usually.
        </p>
        
        <div className="mt-4">
          <p className="text-lg">
            Navigating you to the safe zone in {" "}
            <span className="font-bold text-blue-600 text-2xl">{countdown}</span> seconds.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;